import { lazy } from 'react';

const Title = lazy(() => import('./Title'));

export { Title };
